import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AbstractTranslatableAlertService, CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";

import { AlertButtonColor } from "../../../alert/alert.model";

import { DEPOSIT_LIMIT_REQUIRED_ALERT_ID } from "./deposit-limit-required-dialog.const";

@Injectable({
	providedIn: "root",
})
export class DepositLimitRequiredDialogService {
	constructor(
		private translatableAlertService: AbstractTranslatableAlertService,
		private store: Store<CoreState>
	) {}

	openDialog() {
		const prefix = "general.dga-deposit-limit-required-dialog";
		this.translatableAlertService.open(
			{
				id: DEPOSIT_LIMIT_REQUIRED_ALERT_ID,
				title: `${prefix}-title`,
				message: `${prefix}-text`,
				hideClose: true,
				dialogConfig: {
					disableClose: true,
				},
				mustBeInteracted: true,
				buttons: [
					{
						text: "general.cancel",
					},
					{
						color: AlertButtonColor.Primary,
						text: `${prefix}-limit`,
						handler: () => {
							this.store.dispatch(RouteAction.navigate(CORE_ROUTE.responsibleGaming.depositLimit));
						},
					},
				],
			},
			[]
		);
	}
}
